// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__U9jb9","links":"Footer_links__4gm66","footer__wrapper-links":"Footer_footer__wrapper-links__gjW6t","footer__RRSS":"Footer_footer__RRSS__UnpeS"};